import Link from 'next/link';
import { PUBLIC_PLANNING_COUNCILS } from '../../lib/planningSeo';
import styles from '../../styles/home-discovery.module.css';

const councils = [...PUBLIC_PLANNING_COUNCILS].sort((a, b) => a.displayName.localeCompare(b.displayName, 'en-GB'));

export default function CouncilDirectory({ compact = false }) {
  return (
    <details className={`${styles.directory} ${compact ? styles.compact : ''}`}>
      <summary>
        <span>{compact ? `${councils.length} council areas · Choose your council` : `Browse all ${councils.length} council areas`}</span>
        <span className={styles.directoryToggle} aria-hidden="true">+</span>
      </summary>
      <nav aria-label="Council planning applications and maps" className={styles.directoryGrid}>
        {councils.map((council) => (
          <div key={council.slug} className={styles.councilRow}>
            <Link href={`/planning-updates/${council.shortCode}`} prefetch={false}>
              <span>{council.displayName}</span><span className={styles.linkHint}>Planning applications →</span>
            </Link>
            <Link href={`/planning-map/${council.shortCode}`} prefetch={false} aria-label={`${council.displayName} planning map`} className={styles.mapLink}>Map ↗</Link>
          </div>
        ))}
      </nav>
    </details>
  );
}
